import React from 'react';

export const Loader: React.FC = () => {
    return (
        <div className="loader-container">
            <div className="loader" />
        </div>
    );
};

export const SkeletonCard: React.FC = () => {
    return (
        <div className="skeleton-card">
            <div className="skeleton skeleton-image" />
            <div className="skeleton skeleton-title" />
            <div className="skeleton skeleton-text" />
            <div className="skeleton skeleton-text" style={{ width: '60%' }} />
        </div>
    );
};
